module.exports = __webpack_public_path__ + "static/media/share-icon.3dc0fe15.svg";